import { useGetSpendingLimits } from '../../../hooks/useGetSpendingLimits';

type TSpendingLimitStatus = 'valid' | 'declined' | 'expired';

export const SpendingLimitBar = ({
  status,
}: {
  status: TSpendingLimitStatus;
}) => {
  const { spendingLimits, loadingSpendingLimits } = useGetSpendingLimits();

  if (loadingSpendingLimits || !spendingLimits) return null;

  // Find the active limit (first in the list)
  const activeLimit = spendingLimits.limits[0];
  if (!activeLimit) return null;

  const creditPercentageUsed =
    activeLimit.maxAmount > 0
      ? ((activeLimit.maxAmount - activeLimit.availableAmount) /
          activeLimit.maxAmount) *
        100
      : 0;

  const mapStatusToColor = (status: TSpendingLimitStatus) => {
    switch (status) {
      case 'valid':
        return 'var(--color-secondary-60, #00b278)';
      case 'expired':
        return 'var(--color-structure-60, #999)';
      case 'declined':
        return 'var(--color-primary-10, #1e1e38)';
    }
  };

  const usedPercentage = status === 'declined' ? 100 : creditPercentageUsed;

  const creditLimitBarBackground = {
    background: `linear-gradient(
      to right, ${mapStatusToColor(status)} ${usedPercentage}%,
      var(--color-structure-95, #f5f5f5) ${usedPercentage}%,
      var(--color-structure-95, #f5f5f5) 100%)`,
  } satisfies React.CSSProperties;

  return (
    <div
      className="flex h-[8px] items-center self-stretch rounded-2xl border border-structure-60"
      style={creditLimitBarBackground}
    />
  );
};
